import { lazy } from "react";
import Loadable from "ui-component/Loadable";

import SalesLayOut from "views/Sales-Sections/SalesLayOut";
const Purchase = Loadable(
  lazy(() => import("../views/Purchase-Sections/purchase/purchase"))
);
// const PruchaseReturn = Loadable(lazy(() => import('../views/purchase/purchaseReturn/PruchaseReturn')));
const PurchaseReturn = Loadable(
  lazy(() => import("../views/Purchase-Sections/purchaseReturn/purchaseReturn"))
);
const PurchaseImport = Loadable(
  lazy(() =>
    import("../views/Purchase-Sections/purchase Import/purchaseImport")
  )
);
const PurchaseOrder = Loadable(
  lazy(() => import("../views/Purchase-Sections/purchaseOrder/PurchaseOrder"))
);

const PurchaseRoute = {
  path: "purchase",
  element: <SalesLayOut />,
  ref:"inventory-purchases",
  children: [
    {
      path: "purchasebill",
      ref:"inventory-purchases-purchase",
      element: <Purchase />,
    },
    {
      path: "purchasebillReturn",
      ref:"inventory-purchases-purchase-return",
      element: <PurchaseReturn />,
    },
    {
      path: "purchaseImport",
      ref:"inventory-purchases-purchase-import",
      element: <PurchaseImport />,
    },
    {
      path: "purchaseOrder",
      ref:"inventory-purchases-purchase-order",
      element: <PurchaseOrder />,
    },
  ],
};

export default PurchaseRoute;
